import { WebChatService } from './web';
export default WebChatService;
